<template>
  <div class="auth-page-wrapper pt-5">
    <div class="auth-one-bg-position auth-one-bg" id="auth-particles">
      <div class="shape">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          version="1.1"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          viewBox="0 0 1440 120"
        >
          <path
            d="M 0,36 C 144,53.6 432,123.2 720,124 C 1008,124.8 1296,56.8
            1440,40L1440 140L0 140z"
          ></path>
        </svg>
      </div>
    </div>

    <div class="auth-page-content">
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <div class="text-center mt-sm-5 mb-4 text-white-50">
              <div style="font-weight: 600; font-size: 30px">CEM</div>
            </div>
          </div>
        </div>
        <div class="login-container position-relative">
          <LoadingPage v-if="loading"></LoadingPage>
          <div class="row justify-content-center">
            <div class="col-md-9 col-lg-7 col-xl-6">
              <div class="card mt-4">
                <div class="card-body p-4">
                  <div class="text-center mt-2">
                    <h5 class="text-primary">{{ $t("t-wellcome-back") }}</h5>
                    <p class="text-muted">
                      {{ $t("t_login_desc") }}
                    </p>
                  </div>
                  <div class="p-2 mt-4">
                    <el-alert
                      v-if="showError"
                      :title="messageError"
                      type="warning"
                      show-icon
                      :closable="true"
                      @close="closeAlert"
                      class="mb-3"
                    />
                    <el-form
                      ref="ruleFormRef"
                      :model="dataForm.value"
                      status-icon
                      :rules="rulesForm"
                      label-width="150px"
                      label-position="top"
                      class="form-login"
                      @submit.prevent
                    >
                      <el-form-item
                        :label="$t('t_login_label_account')"
                        prop="account"
                      >
                        <el-input
                          type="text"
                          autocomplete="off"
                          v-model="dataForm.value.account"
                          tabIndex="1"
                          autofocus
                          v-on:keyup.enter="nextFocus"
                        />
                      </el-form-item>
                      <el-form-item
                        :label="$t('t_login_label_password')"
                        prop="password"
                      >
                        <el-input
                          type="password"
                          autocomplete="off"
                          v-model="dataForm.value.password"
                          show-password
                          tabIndex="2"
                          id="inputPass"
                        />
                      </el-form-item>
                      <el-form-item
                        v-if="showTypeLogin"
                        prop="typeLogin"
                        class="type-login"
                      >
                        <el-radio-group
                          v-model="dataForm.value.typeLogin"
                          class="ml-4"
                        >
                          <el-radio label="probe" size="large">PROBE</el-radio>
                          <el-radio label="bras" size="large">BRAS</el-radio>
                        </el-radio-group>
                      </el-form-item>

                      <el-form-item>
                        <el-button
                          type="button"
                          class="btn btn-success btn-load w-100"
                          @click="loginForm(ruleFormRef)"
                          tabindex="3"
                          native-type="submit"
                        >
                          {{ $t("t-login") }}
                        </el-button>
                      </el-form-item>
                      <div class="text-center">
                        {{ $t("t_login_forgot_password") }}
                        <a
                          @click="goForgotPassword()"
                          style="color: #409eff; cursor: pointer"
                          >{{ $t("t_login_recover_password") }}</a
                        >
                      </div>
                    </el-form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, reactive, onMounted, onBeforeUnmount } from "vue";
import { FormInstance } from "element-plus";
import { useRouter, useRoute } from "vue-router";
import LoadingPage from "../../components/loading.vue";
import mushroom from "cem-primary-api";
import MethodService from "../../service/MethodService";
import toastr from "toastr";
import Swal from "sweetalert2";
import { useI18n } from "vue-i18n";
const { t } = useI18n();
const ruleFormRef = ref(FormInstance);
const router = useRouter();
const route = useRoute();

let loading = ref(false);
const showTypeLogin = ref(false);
const showError = ref(false);
const messageError = ref("");
const countLogin = ref(0);
const timeRemainingLeft = ref("");
let countdownTimer = null;

// dữ liệu form
let dataForm = reactive({
  value: {
    account: "",
    password: "",
    typeLogin: "",
  },
});
// validate form
const rulesForm = reactive({
  account: [
    { trigger: "blur", required: true, message: t("t_login_validate_account") },
  ],
  password: [
    {
      trigger: "blur",
      required: true,
      message: t("t_login_validate_password"),
    },
  ],
  typeLogin: [
    {
      trigger: "blur",
      required: true,
      message: t("t_login_validate_type"),
    },
  ],
});

// Tính thời gian còn lại khi tài khoản bị khóa
const calcTimeRemaining = (timeLock, timeRelease, serverTime) => {
  let timeL;
  const now = serverTime
    ? new Date(serverTime).getTime()
    : new Date().getTime();
  if (now < new Date(timeLock).getTime()) {
    timeL = new Date(timeLock).getTime();
  } else {
    timeL = now;
  }
  const timeR = new Date(timeRelease).getTime();
  const timeRemaining = timeR - timeL;

  if (timeRemaining <= 0) {
    showError.value = false;
    clearCountdownTimer();
    return;
  }

  const minute = Math.floor(timeRemaining / 60000);
  const second = Math.floor((timeRemaining % 60000) / 1000);
  const secondFormat = second < 10 ? `0${second}` : second;

  timeRemainingLeft.value = `${minute} ${t(
    "t_login_minute",
  )} ${secondFormat} ${t("t_login_second")}`;
  messageError.value = t("t_login_account_locked", {
    time: timeRemainingLeft.value,
  });

  countdownTimer = setTimeout(() => {
    const nextServerTime = serverTime
      ? new Date(new Date(serverTime).getTime() + 1000).toISOString()
      : null;
    calcTimeRemaining(timeLock, timeRelease, nextServerTime);
  }, 1000);
};

const clearCountdownTimer = () => {
  if (countdownTimer) {
    clearTimeout(countdownTimer);
    countdownTimer = null;
  }
};

const closeAlert = () => {
  showError.value = false;
};

// function
const loginForm = async (formEl) => {
  if (!formEl) return;
  const isValid = await formEl.validate().catch(() => false);
  if (!isValid) return;

  loading.value = true;
  try {
    await mushroom.$auth.loginAsync(
      dataForm.value.account,
      dataForm.value.password,
      true,
    );

    const resMe = await mushroom.$auth.meAsync();

    if (resMe.result?.roles?.includes("NoneWebGUI")) {
      const roles = resMe.result.roles;
      const otherRoles = roles.filter(
        (role) => role !== "NoneWebGUI" && role !== "QueryAPI" && role !== "User"
      );
      if (otherRoles.length === 0) {
        window.localStorage.clear();
        try {
          await mushroom.$auth.logoutAsync({ mode: "invalidClientSession" });
        } catch (e) {
          console.error("Có lỗi: %o", e);
        }

        await Swal.fire({
          title: t("t_warning"),
          text: t("t_not_access"),
          icon: "warning",
          confirmButtonColor: "#3085d6",
          confirmButtonText: t("swal_accept"),
          allowOutsideClick: false,
        });
        return;
      }
    }

    const typeLogin = showTypeLogin.value ? dataForm.value.typeLogin : "probe";
    localStorage.setItem("type_login", typeLogin);

    // Kiểm tra chính sách đổi mật khẩu
    const mustChangePassword = await MethodService.checkNeedToChangePassword({
      router,
      t,
    });
    if (mustChangePassword) return;

    // Xử lý redirect_url từ probe (khi probe bị đăng xuất và chuyển về primary login)
    const redirectUrlFromProbe = route.query.redirect_url;
    if (redirectUrlFromProbe) {
      const token = window.localStorage.getItem(
        "mushroom.tokens[" + mushroom.$using() + "]",
      );
      // redirect_url đã chứa đầy đủ params (system_type, pid_probe, pid_summary, lang, menu)
      // Chỉ cần append access_token vào
      const separator = redirectUrlFromProbe.includes("?") ? "&" : "?";
      const urlPrimary = encodeURIComponent(window.location.origin);

      // Lấy url_probe và url_summary từ API
      let probeBaseUrl = "";
      let summaryBaseUrl = "";
      const typeLogin = localStorage.getItem("type_login") || "probe";
      try {
        const probeResponse = await mushroom.probe.get_probesAsync({
          body: {},
        });
        if (probeResponse.result && probeResponse.result.length > 0) {
          const probeOfType = probeResponse.result.find(
            (p) => p.type === typeLogin,
          );
          const summaryProbe = probeResponse.result.find(
            (p) => p.type === "summary",
          );
          probeBaseUrl = MethodService.extractBaseUrl(probeOfType?.url || "");
          summaryBaseUrl = MethodService.extractBaseUrl(
            summaryProbe?.url || "",
          );
        }
      } catch (e) {
        console.error("Có lỗi khi lấy probe data: %o", e);
      }
      const urlProbe = encodeURIComponent(probeBaseUrl);
      const urlSummary = encodeURIComponent(summaryBaseUrl);

      let finalRedirectUrl = redirectUrlFromProbe;
      finalRedirectUrl += `${separator}access_token=${encodeURIComponent(
        token || "",
      )}`;
      finalRedirectUrl += `&urlPrimary=${urlPrimary}`;
      finalRedirectUrl += `&url_probe=${urlProbe}`;
      finalRedirectUrl += `&url_summary=${urlSummary}`;
      finalRedirectUrl += `&type_login=${typeLogin}`;

      window.location.href = finalRedirectUrl;
      return;
    } else await router.push({ name: "default" });
  } catch (e) {
    if ((e?.code === 37000 && e?.meta?.locked) || e?.code === 37001) {
      // Tài khoản bị khóa do nhập sai quá số lần quy định
      clearCountdownTimer();
      showError.value = true;
      calcTimeRemaining(
        e.meta.lockedTime,
        e.meta.releaseTime,
        e.meta.serverTime,
      );
    } else if (e?.code === 37000) {
      // Sai tài khoản/mật khẩu, còn lượt đăng nhập
      clearCountdownTimer();
      countLogin.value = e?.meta?.remainingCount || 0;
      showError.value = true;
      messageError.value = t("t_login_wrong_credentials", {
        count: countLogin.value,
      });
    } else if (e?.code === 401) {
      toastr.error(t("t_login_ldap_error"));
    } else if (e?.code === 502) {
      toastr.error(t("t_login_ldap_server_error"));
    } else if (e?.code === 503) {
      toastr.error(t("t_login_ldap_not_config_error"));
    } else {
      MethodService.showError(e.code);
    }
  } finally {
    loading.value = false;
  }
};

const goForgotPassword = () => {
  let urlLogin = location.origin + "/forgot-password";
  window.location.href = urlLogin;
};

const nextFocus = () => {
  document.getElementById("inputPass").focus();
};

onMounted(() => {
  if (
    window.location.host.includes("localhost") ||
    window.location.host.includes("siten.vn")
  )
    showTypeLogin.value = true;
  else showTypeLogin.value = false;
});

onBeforeUnmount(() => {
  clearCountdownTimer();
});
</script>
<style scoped lang="scss">
::v-deep.form-login {
  .el-form-item__error {
    top: 35px;
  }
  .el-form-item {
    margin-bottom: 25px;
  }
}
::v-deep.type-login {
  .el-radio.el-radio--large {
    height: 30px;
  }
  .el-form-item__error {
    top: 26px;
  }
  label {
    margin-bottom: 0;
  }
}
</style>
